import { ChangeEvent, FC, useState } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseButton, BaseInput, BaseModal } from 'wbs-components-lib';

import { Box } from '@mui/system';

import { TelegramChatStatusesEnum } from '@shared/constants';

import { useUpdateTelegramStatusMutation } from '@services';

import { AppDispatch } from '@store';

import { TelegramChatFinishSettingsModalProps } from './types';

import styles from './TelegramChatFinishSettingsModal.module.css';

const { telegramChatFinishSettingsModalContent } = styles;

export const TelegramChatFinishSettingsModal: FC<TelegramChatFinishSettingsModalProps> = ({
  isOpened,
  handleClose,
  telegramChat,
  updateTelegramChat,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [comment, setComment] = useState('');

  const [closeTelegramChat] = useUpdateTelegramStatusMutation();

  const handleCommentChange = (event: ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value);
  };

  const handleCloseTelegramChat = async (status: TelegramChatStatusesEnum) => {
    const closedTelegramChat = await closeTelegramChat({
      telegramChatId: telegramChat.id,
      payload: { status, comment },
    }).unwrap();

    dispatch(updateTelegramChat(closedTelegramChat));

    toast.success('Success: Telegram chat has been finalized.!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Finish TelegramChat" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <Box className={telegramChatFinishSettingsModalContent}>
        <BaseInput
          value={comment}
          onChange={handleCommentChange}
          caption="Comment"
          captionColor="#000000"
          placeholder="Enter comment"
        />
        <Box sx={{ display: 'flex', gap: '5px' }}>
          <BaseButton onClick={() => handleCloseTelegramChat(TelegramChatStatusesEnum.CLOSED)}>Finish</BaseButton>
          <BaseButton onClick={handleClose} isDeleteButton>
            Cancel
          </BaseButton>
        </Box>
      </Box>
    </BaseModal>
  );
};
